import { SCOPED_SEARCH_KEYS } from '../../../components/CatalogFilterModel/catalogSearchScope';

/**
 * Strips the scoped-search keys from persisted `filters` state at hydration.
 *
 * These keys were previously written into `filters` by the old free-text
 * filter bar, but are now owned exclusively by the scoped-search control
 * (written into the API request via `searchFilterPatch` at fetch time, never
 * into persisted `filters` state). Stripping them prevents a stale
 * pre-scoped-search bookmark from silently constraining results.
 */
export function stripScopedSearchKeys(
  filters: Record<string, unknown>,
): Record<string, unknown> {
  const result = { ...filters };
  for (const key of SCOPED_SEARCH_KEYS) {
    delete result[key];
  }
  return result;
}
